import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    product: {
      title: '产品服务',
      links: [
        { label: '全部产品', to: '/categories' },
        { label: '新品推荐', to: '/categories?tab=new' },
        { label: '热销排行', to: '/categories?tab=hot' },
        { label: '购买指南', to: '/articles' },
      ],
    },
    about: {
      title: '关于我们',
      links: [
        { label: '品牌故事', to: '/about' },
        { label: '核心理念', to: '/about#values' },
        { label: '用户口碑', to: '/about#reputation' },
        { label: '联系我们', to: '/about#contact' },
      ],
    },
    help: {
      title: '帮助支持',
      links: [
        { label: '常见问题', to: '/articles?category=faq' },
        { label: '使用教程', to: '/articles?category=guide' },
        { label: '售后服务', to: '/about#contact' },
        { label: '隐私政策', to: '/articles' },
      ],
    },
  };

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-bold text-background-50">
                性巴克
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-5 max-w-xs">
              性巴克是一个独特的品牌与文化符号，致力于为用户带来全新的生活体验与价值感受。探索性巴克，发现更多可能。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800/50 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-300" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800/50 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-300" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800/50 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-300" aria-label="小红书">
                <i className="ri-red-packet-line text-base"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="font-label text-sm font-semibold text-background-50 mb-4 tracking-wide">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 性巴克 版权所有。保留所有权利。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">服务条款</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">Cookie 设置</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}